<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportsFiltersTeams',
  props: {
    enableScroll: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: String,
      default: '',
    },
    minWidth: {
      type: String,
      default: '',
    },
    style: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['teamFilterSelection'],
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters({
      options: 'teams/getTeams',
    }),
    scrollBehavior() {
      return this.enableScroll ? 'auto' : 'visible';
    },
    computedMaxHeight() {
      return this.maxHeight || 'none';
    },
    computedMinWidth() {
      return this.minWidth || 'auto';
    },
  },
  mounted() {
    this.$store.dispatch('teams/get');
  },
  methods: {
    handleInput() {
      this.$emit('teamFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small" :style="{ minWidth: computedMinWidth, ...style }">
    <multiselect
      multiple
      v-model="selectedOption"
      class="no-margin"
      :close-on-select="false"
      :clear-on-select="false"
      hide-selected
      :placeholder="$t('TEAM_REPORTS.FILTER_DROPDOWN_LABEL')"
      label="name"
      track-by="id"
      :options="options"
      :option-height="24"
      :show-labels="false"
      @update:model-value="handleInput"
    />
  </div>
</template>

<style scoped>
/* 限制下拉框高度，只显示3.5个选项，支持内部滚动 */
:deep(.multiselect__content) {
  max-height: v-bind(computedMaxHeight) !important;
  overflow-y: v-bind(scrollBehavior) !important;
}

:deep(.multiselect__option) {
  height: 32px !important;
  line-height: 32px !important;
  padding: 0 8px !important;
}
</style>

